(function ($, Drupal) {

  Drupal.behaviors.menu = {
    attach() {
      $(document).ready(function () {

        var selectedMenuTarget;
        var selectedMenuCurrent;
        const megaMenuContainer = $('.header__mega-menu');

        // Toggle open close
        $('.menu li').on("mouseover", function () {

          // Reset active state to selected target
          $('.menu li').removeClass('active');
          $(this).addClass('active');

          // Retrieve our target, we will use this to compare which mini-layout to show
          selectedMenuTarget = $(this).text().trim().split(" ").join("-").toLowerCase();

          // Match if this is the first time opening.
          // If it's not the first time, we will reset the shown mini-layout
          if (typeof selectedMenuCurrent === 'undefined') {
            selectedMenuCurrent = selectedMenuTarget;
          } else {
            if (selectedMenuTarget != selectedMenuCurrent) {
              $('.header__mega-menu-item').removeClass('show');
              selectedMenuCurrent = selectedMenuTarget;
            }
          }

          // Here we match the mini-layout, if there's a match we will show the specific one
          // Otherwise we will be showing the 'combined' mini-layout
          var targetMegamenuItem = $('.header__mega-menu-item[data-menu-type="' + selectedMenuTarget + '"]');

          if (targetMegamenuItem.length > 0) {
            targetMegamenuItem.addClass('show');
          } else {
            $('.header__mega-menu-item[data-menu-type="combined"]').addClass('show');
          }

          // Opening of the mega menu
          if (!megaMenuContainer.hasClass('open')) {
            megaMenuContainer.toggleClass('open');
          }

        });

        // Close on mouse leave header
        $('.header').on("mouseleave", function () {
          $('.menu li').removeClass('active');

          setTimeout( function() {
            if (megaMenuContainer.hasClass('open')) {
              megaMenuContainer.toggleClass('open');
            }
          }, 250);

        });

      });
    },
  };

  Drupal.behaviors.footer_menu_mobile = {
    attach() {
      $(document).ready(function () {
        const menu_selector = $('.menu__level-2');

        menu_selector.on("click", function (event) {
          event.stopImmediatePropagation();

          if ($(window).width() < 1040) {
            $(this).toggleClass('show');
          }
        });

      });
    },
  };

  Drupal.behaviors.header_menu_mobile = {
    attach() {
      $(document).ready(function () {

        const trigger_selector = $('#block-wingsuit-hamburgerlogo');

        trigger_selector.on("click", function (event) {
          event.stopImmediatePropagation();

          $('body').toggleClass('menu-open');
        });

      });
    },
  };


}(jQuery, Drupal));
